/* eslint-disable better-mutation/no-mutation */
import { createSlice } from '@reduxjs/toolkit';
import { normalize } from './helpers';
import { initialState } from './initial-state';

const slice = createSlice({
    name: 'discover',
    initialState,
    reducers: {
        initialize: (_state, { payload }) => {
            return { ...payload };
        },
        requestSearchResults: (state) => {
            state.error = null;
        },
        receiveSearchResults: (state, { payload }) => {
            const {
                result = {},
                endpoint = null,
                queryParams = null,
                shippingRegionCountryCodeIso2 = 'se'
            } = payload;

            return {
                ...state,
                endpoint,
                error: null,
                hasResult: true,
                queryParams,
                ...normalize(result, shippingRegionCountryCodeIso2)
            };
        },
        handleSearchResultsError: (state, { payload }) => {
            state = { ...normalize({}) };
            state.error = payload;
            state.hasResult = true;
        },
        setSingleFilterValue: (state, { payload }) => {
            state.filters = {
                ...state.filters,
                [payload.filter]: {
                    ...state.filters[payload.filter],
                    selectedValue: payload.value
                }
            };
        },
        updateItem: (state, { payload }) => {
            const { itemId, ...itemData } = payload;
            return {
                ...state,
                items: [
                    ...state.items.map((x) =>
                        x.itemId === itemId ? { ...x, ...itemData } : x
                    )
                ],
                itemsOnDisplay: [
                    ...state.itemsOnDisplay.map((x) =>
                        x.itemId === itemId ? { ...x, ...itemData } : x
                    )
                ]
            };
        },
        addItemOnDisplay: (state, { payload }) => {
            return state.itemsOnDisplay.some(
                (x) => x.itemId === payload.item.itemId
            )
                ? state
                : {
                      ...state,
                      itemsOnDisplay: [...state.itemsOnDisplay, payload.item]
                  };
        },
        removeItemOnDisplay: (state, { payload }) => {
            return state.itemsOnDisplay.some(
                (x) => x.itemId === payload.item.itemId
            )
                ? {
                      ...state,
                      itemsOnDisplay: state.itemsOnDisplay.filter(
                          (x) => x.itemId !== payload.item.itemId
                      )
                  }
                : state;
        },
        setCategoryPath: (state, { payload }) => {
            state.categoryPath = payload;
            state.currentCategoryId = (payload && payload[0].id) || 0;
        },
        setCurrentCategoryId: (state, { payload }) => {
            state.currentCategoryId = payload;
        },
        setIsFilterOpen: (state, { payload }) => {
            state.isFilterOpen = payload;
        },
        reset: (state, { payload }) => {
            state = payload.initialState;
        }
    }
});

export const {
    initialize,
    requestSearchResults,
    receiveSearchResults,
    handleSearchResultsError,
    setSingleFilterValue,
    updateItem,
    addItemOnDisplay,
    removeItemOnDisplay,
    setCategoryPath,
    setIsFilterOpen,
    setCurrentCategoryId,
    reset
} = slice.actions;
export const reducer = slice.reducer;
